export default {
  setLoggedIn (state) {
    state.authenticated = true
  },
  setLoggedOut (state) {
    state.authenticated = false
    state.profile = null
  },
  setUserProfile (state, payload) {
    state.profile = payload
  },
  setUserSubscription (state, payload) {
    state.subscription = payload
  },
  setLoginInProgress (state, payload) {
    state.isLoginInProgress = payload
  },
  setPendingAccountSelection (state, payload) {
    state.pendingAccountSelection = !!payload
  }
}
